module.exports = __webpack_public_path__ + "static/img/jidi2.60c40fea.png";